
//公共库
import { Component, Vue } from "vue-property-decorator";

//本地引入
import Pagination from "@/comp/Pagination/index.vue";
import { intimacyList } from "@/api/request/intimacy";

//组件
@Component({
  name: "IntimacyList",
  components: {
    Pagination,
  },
})

//界面函数
export default class extends Vue {
  //定义变量
  private list: any[] = [];
  private total: number = 0;
  private listLoading: boolean = false;

  //列表请求参数
  private listQuery: any = {
    //页面数据
    page: 1,
    page_size: 20,

    //临时数据
    user_id_str: "", //用户ID
    blogger_id_str: "", //博主ID

    //请求数据
    level: -1, //等级
    user_id: 0, //用户ID
    blogger_id: 0, //博主ID
  };

  //等级列表
  private levelList: any[] = [
    { level: -1, name: "全部等级" },
    { level: 0, name: "等级0" },
    { level: 1, name: "等级1" },
    { level: 2, name: "等级2" },
    { level: 3, name: "等级3" },
    { level: 4, name: "等级4" },
    { level: 5, name: "等级5" },
    { level: 6, name: "等级6" },
    { level: 7, name: "等级7" },
    { level: 8, name: "等级8" },
    { level: 9, name: "等级9" },
    { level: 10, name: "等级10" },
  ];

  //创建
  created() {
    //获取列表
    this.getList();
  }

  //获取列表
  private async getList() {
    //显示等待
    this.listLoading = true;

    //数据赋值
    this.listQuery.user_id = Number(this.listQuery.user_id_str);
    this.listQuery.blogger_id = Number(this.listQuery.blogger_id_str);

    //获取数据
    const { data } = await intimacyList(this.listQuery);

    //数据赋值
    this.list = data.list;
    this.total = data.total;

    //隐藏等待
    setTimeout(() => {
      this.listLoading = false;
    }, 0.5 * 1000);
  }

  //处理查询
  private handleFilter(): void {
    //数据赋值
    this.listQuery.page = 1;

    //获取列表
    this.getList();
  }
}
